import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { addWipRecordFromScheduleApi } from 'api/wip';
import type { AddWipRecordFromScheduleRequestBodyDTO } from 'declarations/dto/wip';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

type UseAddWipRecordFromScheduleParamsT = {
  onSuccess?: UseMutationOptions<
    void,
    ApiErrorI,
    AddWipRecordFromScheduleRequestBodyDTO
  >['onSuccess'];
};

export const useAddWipRecordFromSchedule = ({
  onSuccess,
}: UseAddWipRecordFromScheduleParamsT): ReturnType<
  typeof useMutation<void, ApiErrorI, AddWipRecordFromScheduleRequestBodyDTO>
> =>
  useMutation<void, ApiErrorI, AddWipRecordFromScheduleRequestBodyDTO>(
    [RequestQueryKeysE.AddWipRecordFromSchedule],
    addWipRecordFromScheduleApi,
    { onSuccess }
  );
